import React from 'react';
import { Target, Settings, Users, Rocket, Handshake } from 'lucide-react';

const pillars = [
  {
    icon: Target,
    title: 'Strategie & Marktkennis',
    description: '15 jaar Belgische B2B-ervaring. Best practices inbegrepen.',
  },
  {
    icon: Settings,
    title: 'Pipeline Machine',
    description: 'Werkend systeem: dataflows, automatisatie, CRM-sturing.',
  },
  {
    icon: Users,
    title: 'Expertise On Demand',
    description: "SDR's, projectleiding en data-specialisten wanneer nodig.",
  },
  {
    icon: Rocket,
    title: 'Executie',
    description: 'We adviseren niet alleen. We voeren uit, aan jouw ritme.',
  },
  {
    icon: Handshake,
    title: 'Gezamenlijk Resultaat',
    description: "Jouw doelen worden onze KPI's.",
  },
];

const FivePillarsSection = () => {
  return (
    <section className="section bg-white">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Eén partner, vijf functies. Altijd op maat.</h2>
          <p className="section-subtitle mx-auto">
            Geen vijf losse partners. Eén team dat denkt, bouwt én uitvoert.
          </p>
        </div>

        <div className="grid md:grid-cols-5 gap-6">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-6 rounded-xl bg-brand-lightBlue border border-brand-blue/10 hover:border-brand-blue/30 transition-all duration-300 hover:shadow-lg"
            >
              <div className="w-14 h-14 rounded-full bg-brand-blue/10 flex items-center justify-center mb-4">
                <pillar.icon className="w-7 h-7 text-brand-blue" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">{pillar.title}</h3>
              <p className="text-sm text-gray-600">{pillar.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FivePillarsSection;
